import { WarningCircle } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

type LoadNoticeProps = {
  message: string
  onRetry: () => void
  busy?: boolean
}

export function LoadNotice({ message, onRetry, busy = false }: LoadNoticeProps) {
  const { t } = useTranslation()

  return (
    <div className="load-notice" role="alert">
      <WarningCircle weight="fill" aria-hidden />
      <span>{message}</span>
      <button type="button" className="load-notice__retry" onClick={onRetry} disabled={busy}>
        {busy ? t('app.loading') : t('app.retry')}
      </button>
    </div>
  )
}
